import { LineageView } from '@/components/Lineage/LineageView';
import { Page } from '@/components/Page';

export const ProjectLineagePage = () => {
  return (
    <Page title="Project Lineage" pageType="projectLineage">
      <div className="relative h-full w-full overflow-hidden">
        <LineageView isFullScreen highlightedUniqueIds={[]} />
      </div>
    </Page>
  );
};
